import { useTheme } from '@mui/material/styles';

function NRJiraMediumPriorityIcon({ height = '24', width = '24', color }) {
  const theme = useTheme();
  const iconColor = color || theme.palette.jiraIntegration?.priorityColors?.medium;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path d="M6 10H18" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M6 14H18" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export default NRJiraMediumPriorityIcon;
